import PageBackTitle from "../../Component/PageBackTitle";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../../src/Config";
import axios from "axios";

function AddGasDetectorType({ isSidebarExpanded }) {
  const [formData, setFormData] = useState({
    mode_name: "",
    description: "",
    manufacturer: "",
    detected_gases: "",
  });

  const [formErrors, setFormErrors] = useState({
    mode_name: "",
    description: "",
    manufacturer: "",
    detected_gases: "",
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error message as user types valid data
    if (value.trim()) {
      setFormErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const errors = {};

    // if (!formData.mode_name.trim()) {
    //   errors.mode_name = "Model Name is required.";
    // }

    if (!formData.detected_gases.trim()) {
      errors.detected_gases = "Detector Type is required.";
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const payload = {
      // model_name : formData.mode_name,
      // description : formData.description,
      // manufacturer : formData.manufacturer,
      detected_gases : formData.detected_gases
    };

    const authKey = localStorage.getItem("authKey");

    try {
      const response = await axios.post(
        `${API_URL}/api/add_gas_detector_type`,
        payload,
        {
          headers: {
            Authorization: authKey,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setSnackbarMessage("Gas detector type added successfully!");
        setSeverity("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          navigate(-1);
        }, 2000);
      } else {
        setSnackbarMessage("Failed to add gas detector type.");
        setSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage("Something went wrong.");
      setSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content">
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">Add Gas Detector Type</PageBackTitle>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-form-body">
            <form>
              {/* Name Field */}
              {/* <div className="form-group">
                <label>
                  Model Name <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    name="mode_name"
                    value={formData.mode_name}
                    onChange={handleChange}
                    placeholder="Enter Mode Name"
                  />
                </div>
                {formErrors.mode_name && (
                  <p className="error-message">{formErrors.mode_name}</p>
                )}
              </div> */}

              {/* Description Field */}

              <div className="form-group">
                <label>
                  Detector Type <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    name="detected_gases"
                    value={formData.detected_gases}
                    onChange={handleChange}
                    placeholder="Enter Detector Type"
                  />
                </div>
                {formErrors.detected_gases && (
                  <p className="error-message">{formErrors.detected_gases}</p>
                )}
              </div>

              {/* <div className="form-group">
                <label>Manufacturer</label>
                <div className="input-group">
                  <input
                    name="manufacturer"
                    value={formData.manufacturer}
                    onChange={handleChange}
                    placeholder="Enter a Manufacturer"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Description</label>
                <div className="input-group">
                  <input
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Enter a Short Description"
                  />
                </div>
              </div> */}
            </form>
          </div>
          <div className="footer">
            <div className="button-group">
              <button className="data-form-save-button" type="submit" onClick={handleSubmit}>
                Save
              </button>
              <button
                type="button"
                className="data-form-cancel-button"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          onClose={handleSnackbarClose}
          severity={severity}
          elevation={6}
          variant="filled"
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default AddGasDetectorType;
